export default ":host {\n  position: absolute;\n  top: 50%;\n  left: 20%;\n}\n\n.handles {\n  text-align: center;\n  margin-bottom: 0.5rem;\n}";